import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { getTooltipStyles } from './styleUtils';
import { Tooltip as RTooltip, PlacesType } from 'react-tooltip';

export interface TooltipProps {
	content?: React.ReactNode;
	theme?: 'dark' | 'light';
	position?: PlacesType;
	children: React.ReactNode;
	id?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
	content,
	theme = 'light',
	position,
	children,
	id = 'my-tooltip'
}) => {
	const styles = getTooltipStyles();
	if (!content) {
		return <>{children}</>;
	}
	return (
		<>
			<div
				data-tooltip-id={id}
				style={styles.tooltipWrapperCss}
				data-tooltip-html={renderToStaticMarkup(<>{content}</>)}
			>
				{children}
			</div>
			<RTooltip id={id} place={position} style={styles.containerCss(theme)} />
		</>
	);
};
